import React from "react";
import withIconComponent from "../withIconComponent";

var Clock = function Clock() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v6h6",
    "data-color": "color-2"
  }));
};

export default withIconComponent("UiClock", false)(Clock);